export const scrollTo = (destination) => document.querySelector(destination).scrollIntoView({ behavior: 'smooth'});